<template lang="pug">
.form.nps-form
  p.form_title(tabindex="0")
    | {{ question }}
  .rating-form_numbers-list(:class="{'is-rated': isRated}")
    .rating-form_numbers-list_item(v-for="item in ratingText"
                                  :class="{'is-selected': item === selectedIndex}"
                                  @click="selectRating(item)"
                                  tabindex="0") {{ item }}
  written-feedback(v-if="selectedIndex > -1"
                  :feedbackText="feedbackResponse"
                  :is-rated="isRated"
                  :selected-index="selectedIndex"
                  @submit="onSubmit")
  .cancel.interactive-icon.active.default-primary(@click="onCancel" tabindex="0" role="button" :aria-label="getString('screen.chat.dismiss_survey', 'Dismiss survey')")
    fa-icon(:icon="['fas', 'x']")
</template>

<script>
import get from 'lodash/get';
import i18n from '../../../mixins/i18n';
import WrittenFeedback from '../WrittenFeedback.vue';

export default {
  name: 'npsForm',
  mixins: [i18n],
  components: {
    WrittenFeedback,
  },
  props: {
    content: {
      type: Object,
      default() {
        return {};
      },
    },
    config: {
      type: Object,
      default() {
        return {
          question: '',
          scores: [
            { score: 0, response: '' },
            { score: 1, response: '' },
            { score: 2, response: '' },
            { score: 3, response: '' },
            { score: 4, response: '' },
            { score: 5, response: '' },
            { score: 6, response: '' },
            { score: 7, response: '' },
            { score: 8, response: '' },
            { score: 9, response: '' },
            { score: 10, response: '' },
          ],
        };
      },
    },
    disabled: Boolean,
  },
  data() {
    return {
      selectedIndex: this.content.value || -1,
      isRated: this.disabled,
    };
  },
  computed: {
    question() {
      return this.getString(
        get(this.config, 'question_langkey', ''),
        { ns: 'configurable', defaultValue: get(this.config, 'question', '') },
      );
    },

    ratingText() {
      return get(this.config, 'scores', []).map(s => s.score);
    },
    activeRatingText() {
      if (!this.selectedIndex) {
        return '';
      }

      return this.ratingText[this.selectedIndex];
    },
    feedbackResponse() {
      if (!this.selectedIndex < 0) {
        return '';
      }
      const item = get(this.config, 'scores', []).find(s => s.score === this.selectedIndex);
      return this.getString(
        get(item, 'response_langkey', ''),
        { ns: 'configurable', defaultValue: get(item, 'response', '') },
      );
    },
  },
  methods: {
    selectRating(rating) {
      if (this.isRated) {
        return false;
      }

      this.selectedIndex = rating;
      this.$nextTick(() => this.$el.querySelector('.rating-form_title').focus());
      return true;
    },
    onSubmit(comments) {
      const payload = {
        comments,
        description: this.activeRatingText,
        type: 'nps',
        value: this.selectedIndex,
      };
      this.isRated = true;
      this.$emit('submit', payload);
    },
    onCancel() {
      this.$emit('cancel', { type: 'nps' });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  border-radius: 4px;
  border: dotted 1px #19ACFD;
  padding: 10px 16px;;
  text-align: center;

  .form_title {
    color: #67737F;
    font-size: 14px;
    font-weight: 300;
    line-height: 19px;
    margin-bottom: 10px;
  }

  .rating_text {
    color: rgba(0, 99, 152, 1);
    font-size: 14px;
    font-weight: 300;
    height: 20px;
    margin-bottom: 2px;
  }

  .rating-icon-container {
    margin-bottom: 32px;
  }

  .rating_icon {
    font-size: 60px
  }

  .cancel {
    display: inline;
  }
}


.rating-form_numbers-list {
  position: relative;
  width: 299px;
  height: 71px;
  padding: 0;
  margin: 10px auto 16px;
  overflow: hidden;

  &.is-rated {

    .rating-form_numbers-list_item {
      background-color: #E5E9F2;

      &.is-selected {
        background-color: #006398;
      }
    }
  }
}
.rating-form_numbers-list_item {
  position: absolute;
  display: inline-block;
  width: 34px;
  height: 34px;
  color: #fff;
  font-size: 20px;
  line-height: 34px;
  text-align: center;
  border-radius: 50%;
  background-color: #5EC5FE;
  cursor: pointer;

  $odd-item-left: 29px;
  $even-items-left: 50px;
  $step: 42px;
  $j: 1;
  $k: 1;

  @for $i from 1 through 11 {

    @if ($i % 2 == 0) {
      @if ($i == 2) {
        &:nth-child(#{$i}) {
          left: $even-items-left;
        }
      } @else {
        &:nth-child(#{$i}) {
          left: $even-items-left + ($step * $j);
        }
        $j: $j + 1;
      }
    } @else {
      @if ($i == 1) {
        &:nth-child(#{$i}) {
          left: $odd-item-left;
        }
      } @else {
        &:nth-child(#{$i}) {
          left: $odd-item-left + ($step * $k);
        }
        $k: $k + 1;
      }
    }
  }

  &:nth-child(odd) {
    top: 0;
  }
  &:nth-child(even) {
    bottom: 0;
  }

  &:hover, &:focus {
    background-color: darken(#5EC5FE, 20%);
  }

  &.is-selected {
    background-color: #006398;
  }
}
</style>
